<template>
  <main>
    <PageHeader page-title="Page not found" />
    <SectionHeader :image="{url: '/img/thishostel/header-confirmation.png'}" />
    <Heading v-bind="{title: '404', subtitle: 'This page doesn\'t exist (yet).'}" />
    <Wysiwyg content="<p>Maybe you were looking for one of these pages:</p><br/>" />
      <Buttons :buttons="buttons" />
    <PageFooter />
  </main>
</template>

<script>

import PageHeader from '@/sections/page-header/PageHeader'
import SectionHeader from '@/sections/section-header/SectionHeader'
import Wysiwyg from '@/components/wysiwyg/Wysiwyg'
import Heading from '@/components/heading/Heading'
import Buttons from '@/components/buttons/Buttons'
import PageFooter from '@/components/page-footer/PageFooter'

let storeModule = undefined

export default {
  components: {
    PageHeader,
    Heading,
    SectionHeader,
    Buttons,
    Wysiwyg,
    PageFooter,
    Buttons
  },
  data() {
    return {
      buttons: [
        {
          link: '/home',
          title: 'Home',
        },
        {
          link: '/inside',
          title: 'Inside',
        },
        {
          link: '/outside',
          title: 'Outside',
        }
      ]
    }
  }
}
</script>
